<h3>
    {{'dashboard.saveForm.save.fullLabel' | translate}}
    <app-tooltip text="{{'dashboard.saveForm.save.summary' | translate}}"></app-tooltip>
</h3>
<form [formGroup]="saveSimuForm" (ngSubmit)="onSubmit(false)">
    <!-- <h3>{{'dashboard.saveForm.save.fullLabel' | translate}}</h3> -->
    <mat-form-field>
        <mat-label>{{'dashboard.saveForm.shortLabel.label.shortLabel' | translate}}</mat-label>
        <input type="text" matInput
            onclick="this.select()"
            formControlName="shortLabel">
        <mat-error>{{'dashboard.saveForm.shortLabel.errorMessage.summary' | translate}}</mat-error>
    </mat-form-field>
    <mat-form-field>
        <mat-label>{{'dashboard.saveForm.summary.label.shortLabel' | translate}}</mat-label>
        <textarea matInput formControlName="summary" rows="6"></textarea>
    </mat-form-field>
    <div class="actions">
        <button mat-raised-button color="accent" type="submit" [disabled]="saveSimuForm.invalid">{{'dashboard.saveForm.save.shortLabel' | translate}}</button>
        <button mat-raised-button color="accent" type="button"
            *ngIf="simulation.isEditable"
            (click)="onSubmit(true)"
            [disabled]="saveSimuForm.invalid">{{'dashboard.saveForm.update.shortLabel' | translate}}</button>
        <button mat-button (click)="onCancel()">{{'dashboard.saveForm.cancel.shortLabel' | translate}}</button>
    </div>
</form>
